// @flow

import { handlePaginatedMapRequest } from '../phasedActionHelpers';

import type { LoadWorksByFilterAction } from '../../actions/work';

export type State = {
  +[key: string]: {|
    +entities: Array<number>,
    +loaded: boolean,
    +loading: boolean,
    +loadedCursors: { +[key: string]: boolean },
    +meta: {
      +count: number,
      +cursor: { +next: ?string, +prev: ?string },
    },
  |},
};

const initialState = {};

export default function worksByFilter(
  state: State = initialState,
  action: LoadWorksByFilterAction
): State {
  if (action.type === 'FETCH_WORKS_BY_FILTER' && action.cacheId) {
    return handlePaginatedMapRequest(state, action, action.cacheId);
  }

  return state;
}
